/* eslint-disable max-params */
import { NUMBER } from "../constants/app-constants";
import { getProfileDetails } from "../components/configuration/actions";
import { useDispatch } from "react-redux";
import { sendOTP, verifyOtp, login } from "../components/shared/with-otp-v2/actions";

const useLogin = () => {

    const dispatch = useDispatch();

    const getOtpHandler = (mobileNumber) => {
        return new Promise((resolve, reject) => {
            sendOTP(mobileNumber, true).then(() => {
                resolve();
                // eslint-disable-next-line no-unused-vars
            }).catch((error) => {
                reject(error);
            });
        });
    };

    const onResendClick = (mobileNumber, callback) => {
        getOtpHandler(mobileNumber);
        callback();
    };

    const fetchProfileDetails = (resolve) => {
        dispatch(getProfileDetails()).then(() => {
            resolve();
        }).catch(() => {
            resolve();
        });

    };

    const onOtpVerify = (otp, mobileNumber = "", errorCallback) => {
        const params = {
            phone_number: mobileNumber,
            otp
        };

        // eslint-disable-next-line consistent-return
        return new Promise((resolve, reject) => {
            verifyOtp(params, true).then(async (response) => {
                if (response.error) {
                    const { error: { error_message: errorMessage } } = response;

                    window.setTimeout(() => {
                        errorCallback(errorMessage);
                    }, NUMBER.FOUR_HUNDRED);
                } else {
                    const responseData = response.data || {};
                    const loginUrl = (response.data || {}).login_url || "";
                    const accessToken = loginUrl.split("access-token=")[1] || responseData["access-token"];
                    const payload = {
                        "access-token": accessToken,
                        redirect_url: encodeURIComponent(window.location.href)
                    };
                    login(payload).then(() => fetchProfileDetails(resolve)).catch(() => fetchProfileDetails(resolve));
                }
            }).catch(error => {
                const errorCode = (error &&
                    error.errors &&
                    error.errors[0] &&
                    error.errors[0].error) || (error && error.message) || "";
                reject(errorCode);
            });
        });
    };

    const checkIfLoginRequired = ({isLoggedIn}) => {
        return new Promise((resolve, reject) => {
            if (isLoggedIn) resolve();
            else reject();
        });
    };

    return { getOtpHandler, onResendClick, onOtpVerify, checkIfLoginRequired };
};

export default useLogin;
